<template>
  <footer class="app-footer">
    &copy; 2026 HypnoMaker &middot;
    <a href="mailto:remedy@hypnomaker.com">Contact</a>
  </footer>
</template>

<script setup>
// static footer shared across all pages
</script>

<style scoped>
.app-footer {
  width: 100%;
  text-align: center;
  color: #391a67;
  font-size: 0.95rem;
  padding: 1.5rem 0 0.7rem;
  letter-spacing: 0.5px;
  user-select: none;
}
.app-footer a {
  color: #391a67;
  text-decoration: underline;
  font-weight: 600;
}
.app-footer a:hover {
  color: #ff3d82;
}
</style>
